import React, {useState} from "react";
import { Box, Column, Columns, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import MovementRateRow from "./MovementRateRow";
import {useMovementsRateData} from "../../../hooks/useMovementsRateData";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getMovementRatesData} from "../../../state/selectors";
import LoadingSpinner from "../../Utils/Spinner";
import NewMovementRate from "./NewMovementRate";
import axios from "axios";
import {createSetDataFreshAction, createSetMovementRateDataAction} from "../../../actions/dataActions";
import {ToastContainer, toast} from "react-toastify";
import FilterBlankHeading from "../../Invoicing/FilterBlankHeading";
import FilterHeading from "../../Invoicing/FilterHeading";
import PaginationWrapper from "../../Utils/PaginationWrapper";


export default function MovementRateView(props){
    const [page, setPage] = useState(1);
    const [filters, setFilters] = useState({});

    const dispatch = useDispatch();
    let dataFresh = useSelector(getDataFresh);
    let params = {page, show_hide: true, show_all: true}

    for (let filter in filters) {
        if (filters[filter][0] && filters[filter][0][filter]) {
          params[filter] = filters[filter][0][filter];
        }
    }


    let loaded = useMovementsRateData(params, dataFresh);
    let data = useSelector(getMovementRatesData);

    const headings = [
        {
            label: "Name",
            field: "name",
            labelField: "name"
        },
        {
            label: "Cost Per Mile"
        },
        {
            label: "Vehicle Cost"
        },
        {
            label: "Additional Time Cost"
        },
        {
            label: "Callout Cost"
        },
        {
            label: "Internal Cost Per Mile"
        },
        {
            label: "Internal One Off Cost"
        },
        {
            label: "External Cost Per Mile",
        },
        {
            label: "External One Off Cost"
        },
        {
            label: "Customer",
            field: "customer",
            labelField: "customer__display_name"
        },
        {
            label: "Comments"
        },
        {
            label: "Hide"
        }
    ]


    const onSave = (item) => {
        let url = item.id ? props.endpoint+"movementrate/"+item.id : props.endpoint+"movementrate";
        const conf = {
            url: url,
            method: item.id ? "put": "post",
            data:item
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error saving this rate", {position: "top-right"});
        })
    }
    const onDelete = item => {
        const conf = {
            url: props.endpoint+"movementrate/"+item.id,
            method: "delete"
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error deleting this rate", {position: "top-right"});
        })
    }
    const onChange = (e,index) => {
        let newResults = [...data.results];
        let newRates = {...data, results: newResults}
        let newRate = {...data.results[index]}
        newRate[e.target.name] = e.target.value;
        newRates.results[index] = newRate
        dispatch(createSetMovementRateDataAction(newRates));
    }


    if(!loaded){
        return (<LoadingSpinner />);
    }

    // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
    return (
        <div>
            <br/>
            <NewMovementRate onSave={onSave}/>
            <Box>
                <details>
                    <summary><Title>Movement Rate</Title></summary>
                    <Columns isMultiline>
                        <Column>
                            <Table isFullwidth>
                                <thead>
                                    <tr>
                                        {headings.map(heading => {
                                            if (!heading.field) {
                                              return <th key={heading.label}>{heading.label}</th>;
                                            }
                                            if (heading.blank) {
                                              return (
                                                <FilterBlankHeading
                                                  key={heading.label}
                                                  heading={heading}
                                                  setFilters={f => {
                                                    setPage(1);
                                                    setFilters(f);
                                                  }}
                                                  filters={filters}
                                                />
                                              );
                                            }
                                            return (
                                              <FilterHeading
                                                key={heading.label}
                                                heading={heading}
                                                setFilters={f => {
                                                  setPage(1);
                                                  setFilters(f);
                                                }}
                                                filters={filters}
                                                options={data.filter_list[heading.field]}
                                              />
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                {data.results.map((rate, index) => (
                                    <MovementRateRow
                                        rate={rate}
                                        handleSave={onSave}
                                        index={index}
                                        handleChange={onChange}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </Column>
                    </Columns>
                    <PaginationWrapper
                        setPage={setPage}
                        page={page}
                        dataCount={Math.ceil(data.count / 25)}
                    />
                </details>
            </Box>
        </div>
    );

}